import { boolean, mixed, number, object, string, type InferType } from 'yup'

export const photoHeroSchema = object({
  // The background image
  image: mixed<File | ContentFile>().required(),
  // Whether to break out of the container
  breakOut: boolean().default(false),
  // The text overlay
  slogan: string().required(),
  // The subtitle overlay
  subtitle: string().default(''),
  // Whether to show the logo overlay
  showLogo: boolean().default(true),
  // The height of the hero
  height: number().default(500),
  // The opacity of the dark overlay
  darkOverlayOpacity: number().default(30),
  // The text alignment
  textAlign: string().oneOf(['left', 'center', 'right']).default('left'),
  // Whether to apply a mask to the bottom of the image
  maskBottomImage: boolean().default(false),
})

export interface PhotoHeroPayload extends InferType<typeof photoHeroSchema> {}
